import React, { useContext, useState } from "react";
import { ReactComponent as DashboardLogo } from "./assets/images/dashboard.svg";
import ChannelOverview from "./components/ChannelOverview";
import CountryCloseup from "./components/CountryCloseup";
import Overview from "./components/Overview";
import ContentHeader from "../../components/ContentHeader";
import AuthContext from "../../contexts/AuthContext";

import "./assets/css/style.css";
import "./components/charts/assets/css/style.css";


const Dashboard: React.FC = () => {

  const { user } = useContext(AuthContext);
  const [content, setContent] = useState<string>(user?.profile.name != "Administrator" ? "countryCloseup" : "overview");

  const changeContent = (content: string) => {
    setContent(content);
  };

  return (
    <div className="wrapperApp">
      <ContentHeader
        title="Dashboard"
        Icon={DashboardLogo}
        breadcrumb={["LATAM OVERVIEW", "ATLAS - LATAM"]}
      />
      <div id="content">
        <div className="tabs">
          <div className="tabs__buttons">
            {["Approver", "Sender"].some(role => user?.profile.name.includes(role)) 
            ?  
              null
            :
              <button
              className={`tabs__tablinks ${content === "overview" ? "tabs__tablinks--active" : ""
                }`}
              onClick={() => {
                changeContent("overview");
              }}
              >
                LATAM Overview
              </button>
          }

          {["Approver", "Sender"].some(role => user?.profile.name.includes(role)) 
            ?  
              null
            :
            <button
              className={`tabs__tablinks ${(content === "channelOverview") ? "tabs__tablinks--active" : ""
                }`}
              onClick={() => {
                changeContent("channelOverview");
              }}
            >
              Plan Overview
            </button>
          }
            <button
              className={`tabs__tablinks ${(content === "countryCloseup") ? "tabs__tablinks--active" : ""
                }`}
              onClick={() => {
                changeContent("countryCloseup");
              }}
            >
              Country Close up
            </button>
          </div>
          <div className="tabs__tabcontent">
            {content == "overview" ? (
              <Overview />
            ) : content === "countryCloseup" ? (
              <CountryCloseup />
            ) : (
              <ChannelOverview />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
